module.exports = __webpack_public_path__ + "TIU_Waybright_Center.7c7c1dc783dc73d2553d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TIU_Waybright_Center.jpg
// module id = 386
// module chunks = 7